import * as $ from 'jquery';    

export const CartShowMoreBtn = (() => {

    const PRODUCTS_OFFER = $('.cart-step2-product');
    const TOGGLER_VIS_BTN = $('#show-more-products-btn');

    const PRODUCTS_CART = $('.cart-step2-product-row');
    const TOGGLER_VIS_BTN_CART = $('#show-more-products-btn-cart');

    //for offer cart
    PRODUCTS_OFFER.slice(0,3).removeClass('product-hide');
    if (PRODUCTS_OFFER.length <= 3) {
        TOGGLER_VIS_BTN.hide();
    } else {
        TOGGLER_VIS_BTN.click( () => {
            if (PRODUCTS_OFFER.hasClass('product-show')){
                TOGGLER_VIS_BTN.text('Pokaż więcej');
            } else {
                TOGGLER_VIS_BTN.text('Pokaż mniej');
            }
            PRODUCTS_OFFER.toggleClass('product-show');
        });
    }

    //for normal cart
    let cartFirstsProducts = PRODUCTS_CART.slice(0,3);
    let cartLastProducts = PRODUCTS_CART.slice(3);
    cartFirstsProducts.removeClass('d-none');
    if (PRODUCTS_CART.length <= 3) {
        TOGGLER_VIS_BTN_CART.hide();
    } else {
        TOGGLER_VIS_BTN_CART.click( () => {
            if (PRODUCTS_CART.hasClass('d-none')){
                TOGGLER_VIS_BTN_CART.text('Pokaż więcej');
            } else {
                TOGGLER_VIS_BTN_CART.text('Pokaż mniej');
            }
            cartLastProducts.toggleClass('d-none');
        });
    }

})();import * as $ from 'jquery';    

export const CartShowMoreBtn = (() => {

    const PRODUCTS_OFFER = $('.cart-step2-product');
    const TOGGLER_VIS_BTN = $('#show-more-products-btn');

    const PRODUCTS_CART = $('.cart-step2-product-row');
    const TOGGLER_VIS_BTN_CART = $('#show-more-products-btn-cart');

    //for offer cart
    PRODUCTS_OFFER.slice(0,3).removeClass('product-hide');
    if (PRODUCTS_OFFER.length <= 3) {
        TOGGLER_VIS_BTN.hide();
    } else {
        TOGGLER_VIS_BTN.click( () => {
            if (PRODUCTS_OFFER.hasClass('product-show')){
                TOGGLER_VIS_BTN.text('Pokaż więcej');
            } else {
                TOGGLER_VIS_BTN.text('Pokaż mniej');
            }
            PRODUCTS_OFFER.toggleClass('product-show');
        });
    }

    //for normal cart
    let cartFirstsProducts = PRODUCTS_CART.slice(0,3);
    let cartLastProducts = PRODUCTS_CART.slice(3);
    cartFirstsProducts.removeClass('d-none');
    if (PRODUCTS_CART.length <= 3) {
        TOGGLER_VIS_BTN_CART.hide();
    } else {
        TOGGLER_VIS_BTN_CART.click( () => {
            if (PRODUCTS_CART.hasClass('d-none')){
                TOGGLER_VIS_BTN_CART.text('Pokaż więcej');
            } else {
                TOGGLER_VIS_BTN_CART.text('Pokaż mniej');
            }
            cartLastProducts.toggleClass('d-none');
        });
    }

})();